<template>
  <card-wrapper title="Program telewizyjny">
    <div class="columns">
      <div class="column is-8-desktop is-offset-2-desktop is-12">
        <div class="card">
          <program-list-header
            :date="currentDate"
            :previous="
              actionsLoaded
                ? currentDate.subtract(1, 'day').format('YYYY-MM-DD')
                : null
            "
            :next="
              actionsLoaded
                ? currentDate.add(1, 'day').format('YYYY-MM-DD')
                : null
            "
            @go-to="goTo"
          />
          <loader :state="actionsValues">
            <div class="card-content">
              <p class="grey-message" v-if="!currentProgram">
                Brak programu na wybrany dzień
              </p>
              <template v-else>
                <program-block
                  v-for="block in currentProgram.blocks"
                  :name="block.name"
                  :items="block.items"
                  :current="currentDate"
                  :now="now"
                  :key="block.id"
                />
              </template>
            </div>
            <template #loading>
              <div class="card-content">
                <div class="spinner is-3by4 is-grey-lighter is-medium" />
              </div>
            </template>
            <template #error>
              <div class="card-content">
                <div class="grey-message">
                  <icon name="fa-times-circle" />
                  <p>
                    Program niedostępny ze względu na brak połączenia z
                    serwerem.
                  </p>
                </div>
              </div>
            </template>
          </loader>
        </div>
      </div>
    </div>
  </card-wrapper>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import { REQUEST_BLOCKS, REQUEST_PROGRAM } from ":actions";

import dayjs from "dayjs";

import { Icon, CardWrapper } from "%helpers";
import ProgramListHeader from "%components/program/ProgramListHeader";
import ProgramBlock from "%components/program/ProgramBlock";

import { WithDispatcherProgress } from "%mixins";

export default {
  name: "program",

  components: {
    Icon,
    CardWrapper,
    ProgramListHeader,
    ProgramBlock
  },

  mixins: [WithDispatcherProgress],

  props: {
    current: String,
    now: dayjs
  },

  mounted() {
    this.dispatchWithProgress("blocks", REQUEST_BLOCKS);
    this.dispatchWithProgress("program", REQUEST_PROGRAM, {
      from: this.currentDateAsString,
      to: this.currentDateAsString
    });

    if (!this.currentDate.isValid()) {
      this.$router.push("/program/today");
    }
  },

  computed: {
    ...mapState({
      program: state => state.program.program
    }),

    ...mapGetters(["programBlocks"]),

    currentProgram() {
      return this.program.find(d => d.date === this.currentDateAsString);
    },

    currentDate() {
      const date = dayjs(this.current);
      return date.isValid() ? date : dayjs();
    },

    currentDateAsString() {
      return this.currentDate.format("YYYY-MM-DD");
    }
  },

  methods: {
    goTo(date) {
      this.$router.push(`/program/${date}`);
    }
  },

  watch: {
    current() {
      this.dispatchWithProgress("program", REQUEST_PROGRAM, {
        from: this.currentDateAsString,
        to: this.currentDateAsString
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.spinner {
  margin: 1rem auto;
  font-size: 4rem;
}
</style>
